import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uv-tile-saleprice",
  "data-onsale": ""
}
const _hoisted_2 = { class: "uv-tile-saleprice-top" }
const _hoisted_3 = {
  key: 0,
  class: "uv-tile-finance"
}
const _hoisted_4 = { class: "uv-tile-saleprice-price" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_6 = { class: "uv-tile-saleprice-saleprice" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_8 = {
  key: 1,
  class: "uv-tile-price"
}
const _hoisted_9 = { class: "uv-tile-price-price" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("sup", null, "$", -1)
const _hoisted_11 = {
  key: 0,
  class: "uv-tile-finance"
}

import { computed } from 'vue'; 
	import { useStore } from 'vuex';
	import { IStoreState, IVehicle } from '@/types.d';
	
	import { commify } from '@/helpers';
	import VehicleFinance from './VehicleFinance.vue';
	import { PriceSlash } from '@/svg';

	
export default /*#__PURE__*/_defineComponent({
  props: {
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
		vehicle: IVehicle
	}

	

	const store = useStore<IStoreState>();

	const disclaimerSymbols = computed(() => props.vehicle.DisclaimerSymbols?.join(''));
	const brandId = computed(() => store.state.brandId);
	

return (_ctx: any,_cache: any) => {
  return (__props.vehicle.OnSale)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.vehicle.Weekly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(VehicleFinance, {
                  weekly: __props.vehicle.Weekly
                }, null, 8, ["weekly"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(brandId) === 2 ? 'WAS ' : '') + " ", 1),
            _createElementVNode("span", null, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_unref(commify)(Math.floor(__props.vehicle.WasPrice))) + " ", 1),
              _createVNode(_unref(PriceSlash))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(brandId) === 2 ? 'NOW ' : '') + " ", 1),
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_unref(commify)(__props.vehicle.Price)) + " ", 1),
            _createElementVNode("sup", null, _toDisplayString(_unref(disclaimerSymbols)), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_unref(commify)(__props.vehicle.Price)) + " ", 1),
          _createElementVNode("sup", null, _toDisplayString(_unref(disclaimerSymbols)), 1)
        ]),
        (__props.vehicle.Weekly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(VehicleFinance, {
                weekly: __props.vehicle.Weekly
              }, null, 8, ["weekly"])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})